"use client";
import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import UniverBackground from "../components/Background";
import SiteHeader from "../components/SiteHeader";
import Footer from "../components/Footer";
import config from "../config/team.json";
import ProjectRedirect from "./ProjectRedirect";
import { isProduction, projectURL } from "../components/lib/site";

const ProjectCard = ({ project }) => (
  <a
    href={projectURL(project.slug)}
    className="background-card group flex flex-col gap-6 p-8 md:p-10 rounded-3xl border border-white/10 hover:border-white/30 transition-colors w-full"
  >
    <div className="flex flex-row items-center gap-4">
      <img src={project.logo} alt="" className="w-14 h-14 rounded-2xl" />
      <span className="text-heading text-2xl md:text-[32px]">
        {project.name}
      </span>
    </div>
    <span className="text-heading text-lg md:text-xl">{project.tagline}</span>
    <span className="text-normal text-sm md:text-base leading-relaxed">
      {project.description}
    </span>
    <div className="flex flex-row flex-wrap items-center justify-between gap-4 mt-auto pt-2">
      <div className="flex flex-row flex-wrap gap-2">
        {project.tags.map((tag) => (
          <span
            key={tag}
            className="text-normal text-xs px-3 py-1 rounded-full border border-white/15"
          >
            {tag}
          </span>
        ))}
      </div>
      <span className="text-heading text-sm text-blue-1 group-hover:translate-x-1 transition-transform">
        Visit →
      </span>
    </div>
  </a>
);

const Home = () => {
  const { intro, projects } = config;
  const { search, hash } = useLocation();

  useEffect(() => {
    document.title = "Endurio";
    if (hash) {
      document.getElementById(hash.slice(1))?.scrollIntoView();
    }
  }, [hash]);

  // Referral links were shared as endur.io/?ref=0x… before PoR moved to its own site.
  const params = new URLSearchParams(search);
  if (params.get("ref") || params.get("startapp")) {
    return isProduction() ? (
      <ProjectRedirect project="por" />
    ) : (
      <Navigate to={`/por/${search}`} replace />
    );
  }

  return (
    <div className="relative flex w-full h-full bg-black">
      <UniverBackground url="" />
      <SiteHeader />
      <div className="absolute flex flex-col justify-center inset-x-0 items-center py-0 px-4 w-full top-[64px] md:top-[80px]">
        <div className="flex flex-col items-center text-center gap-6 max-w-[720px] pt-[100px] md:pt-[160px] pb-[100px] md:pb-[160px]">
          <span className="text-heading text-[40px] md:text-[72px] leading-tight">
            {intro.heading}
          </span>
          <span className="text-heading text-xl md:text-2xl">
            {intro.tagline}
          </span>
          <span className="text-normal text-base md:text-lg leading-[30px]">
            {intro.explain}
          </span>
        </div>
        <div
          id="projects"
          className="flex flex-col items-center gap-10 md:gap-14 w-full max-w-[1200px] scroll-mt-[100px]"
        >
          <span className="text-heading text-[34px] md:text-[48px]">
            Projects
          </span>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 w-full">
            {projects.map((project) => (
              <ProjectCard key={project.name} project={project} />
            ))}
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Home;
